import { render } from "./CalendarWidget.vue?vue&type=template&id=061442e4&scoped=true"
import script from "./CalendarWidget.vue?vue&type=script&lang=js"
export * from "./CalendarWidget.vue?vue&type=script&lang=js"

import "./CalendarWidget.vue?vue&type=style&index=0&id=061442e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-061442e4"]])

export default __exports__